import React, { useEffect, useState } from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import withStyles from '@material-ui/core/styles/withStyles';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { ClickAwayListener, makeStyles } from '@material-ui/core';
import ClickDropDown from 'components/UI/ClickDropDown';
import CohereIcon from 'assets/coherelogo.png';
import DummyImage from 'assets/CrousalItem1.png';
import { FormControlLabel } from '@material-ui/core';
import { PhonePreviewVector, PhoneDesktop } from '../../../CreateCampaign/Pages/DesignPage/assests/SvgImages';
import Checkbox from '@material-ui/core/Checkbox';
import classes from './Campaign.module.scss';
import { ImGift } from 'react-icons/im';
import HoverableImage from '../HoverableImage/HoverableImage';
import DropDownList from 'components/UI/DropDownList/DropDownList';
import { Link } from 'react-router-dom';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import moment from 'moment';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { addhttp } from 'utils/utils';
import useRouter from 'hooks/useRouter';
import { PER_PAGE_CAMPAIGNS_COUNT } from 'pages/EmailCampaigns/Styles/Constants/constants';
import { CampaignStatus } from 'pages/CreateCampaign/Constants/constants';
import { Tooltip } from '@material-ui/core';
import { CampaignServices } from 'pages/EmailCampaigns/Services/AllCampaigns.service';
import { fetchAllEmailCampaignsAsync } from 'actions/campaign';
import { useDispatch } from 'react-redux';
import Modal from 'components/UI/Modal';
import { rest } from 'lodash';
import { createCampaignServices } from 'pages/CreateCampaign/Services/CreateCampaign.service';

const StyledDropDownWrapper = styled.div`
  position: relative;
`;

const StyledContactsCount = styled.div`
  cursor: pointer;
  font-family: Avenir;
  font-weight: bold;
  &:hover {
    text-decoration: underline;
  }
`;

const StyledDropDownItem = styled(Link)`
  font-family: Avenir;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #4a4a4a;
  text-decoration: none;
  white-space: nowrap;
  background-color: white;
  padding: 8px 20px;
  border-bottom: 1px solid #f0f0f0;
  min-width: 100px;
  width: 100%;
  height: 45px;
  display: flex;
  align-items: center;
  text-align: left;

  ${({ isDisabled }) =>
    isDisabled &&
    `
    opacity: 1;
    color: gray;
    cursor: pointer;
  
  `}

  &:hover {
    text-decoration: underline;
    ${({ isDisabled }) =>
      isDisabled &&
      `
    text-decoration: none;
    opacity: 1;
    color: gray;
  
  `}
  }
`;

const ContributionTitle = styled.div`
  cursor: pointer;
  font-size: 0.875rem;
  font-family: Avenir;
  margin-bottom: 5px;
  font-weight: bold;
  &:hover {
    text-decoration: underline;
  }
`;

const NarrowTableCell = withStyles({
  root: {
    paddingTop: 8,
    paddingBottom: 8,
  },
})(TableCell);

const HyperLink = styled.div`
  cursor: pointer;
  text-decoration: underline;
  &:hover {
    text-decoration: underline;
  }
`;

const StyledImage = styled.img`
  width: 56px;
  height: 56px;
  border-radius: 4px;
  border: 1px solid #dfe3e4;
`;

const StyledDropDown = styled.div`
  position: absolute;
  width: 150px;
  top: 15px;
  right: 20px;
  z-index: 1;
  box-shadow: 0px 6px 30px 0px rgba(33, 92, 115, 0.32);
`;
const TooltipText = 'There are no clients for this service yet';
export const TRIAL_PERIOD_START_DATE = '2021-11-01';
export const TRIAL_PERIOD_DAYS = 13;
const Dummy_Template =
  '<!doctype html>\n<html>\n\t<head>\n\t</head>\n\t<body style="\n\t\tfont: 12px Tahoma, sans-serif;\n\t\tbackground-color: #e5e5e5;\n\t\tdisplay: flex;\n\t\theight: auto;\n\t\talign-items: center;\n\t\tposition: relative;\n\t\tflex-direction: column;">\n\t\t<table align="center" cellspacing=0>\n\t\t\t<tr>\n\t\t\t\t<td align="center" style="background-color: #ffffff;">\n\t\t\t\t\t<div style="\n\t\t\t\t\tpadding-top: 50px;\n\t\t\t\t\tpadding-bottom: 50px;">\n\t\t\t\t\t\t<img height="128" src="https://coherepublic-test.s3.amazonaws.com/626963f9381c7427157e4c3e/f46e486f-1209-451b-89a2-45d316ea6d2b.png">\n\t\t\t\t\t</div>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td style="background-color: #ffffff;">\n\t\t\t\t\t<div style="padding: 50px;\n\t\t\t\t\tbackground-color: #0b6481;\n\t\t\t\t\tcolor: transparent">\n\t\t\t\t\t\t<h1 style="font-family: Roboto, sans-serif;\n\t\t\t\t\t\tcolor: #ffffff;\n\t\t\t\t\t\tfont-size: 45px;\n\t\t\t\t\t\tline-height: 45px;\n\t\t\t\t\t\ttext-align: center">\n\t\t\t\t\t\t\tCongrats on your Service!\n\t\t\t\t\t\t</h1>\n\t\t\t\t\t\t<h3 style="margin-top: 25px;\n\t\t\t\t\t\tfont-family: Roboto, sans-serif;\n\t\t\t\t\t\tcolor: #ffffff;\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\ttext-align: center">\n\t\t\t\t\t\t\tThis is an automated email to notify you that you have a new client!\n\t\t\t\t\t\t</h3>\n\t\t\t\t\t</div>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td style="background-color: #ffffff;">\n\t\t\t\t\t<div style="padding: 50px;">\n\t\t\t\t\t\t<h3 style="font-family: Roboto, sans-serif;\n\t\t\t\t\t\ttext-align: justify;\n\t\t\t\t\t\tcolor: #5c5c5c;\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\tfont-weight:300;\n\t\t\t\t\t\tline-height: 26px;">\n\t\t\t\t\t\t\tCongrats, {cohealerFirstName}! Your client {clientEmail} just enrolled into {contributionName} & paid {currencySymbol}{paidAmount} {currencyCode}.\n\t\t\t\t\t\t\t<br>\n\t\t\t\t\t\t\tKeep up the great impact you\'re making!\n\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t<h3 style="font-family: Roboto, sans-serif;\n\t\t\t\t\t\ttext-align: justify;\n\t\t\t\t\t\tcolor: #5c5c5c;\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\tfont-weight:300;\n\t\t\t\t\t\tline-height: 26px;">\n\t\t\t\t\t\t\tBest wishes,<br>\n                            Team Cohere\n\t\t\t\t\t\t</h3>\n\t\t\t\t\t</div>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td align="center" style="background-color: #ffffff;"> \n\t\t\t\t\t<div style=" padding-top: 50px;\n\t\t\t\t\tpadding-bottom: 50px;">\n                        <a href="{loginLink}"\n                        style="padding: 12px 70px;\n\t\t\t\t\t\tbackground-color: #d1b989;\n\t\t\t\t\t\tfont-family: Roboto, sans-serif;\n\t\t\t\t\t\tfont-weight: 800;\n\t\t\t\t\t\tcolor: #ffffff;\n\t\t\t\t\t\tletter-spacing: 3px;">Login</a>\n\t\t\t\t\t</div>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td>\n\t\t\t\t\t<p style="font-family: Roboto, sans-serif; color: #5c5c5c; font-size: 12px; line-height: 24px; text-align: center;">\n                        <a style="font: inherit; color: inherit; text-decoration: none;" href="{unsubscribeEmailLink}">Unsubscribe</a>\n                        |\n                        <a style="font: inherit; color: inherit; text-decoration: none;" href="mailto:support@cohere.live">Contact Support</a>\n                    </p>\n                </td>\n\t\t\t</tr>\n\t\t</table>\n\t</body>\n</html>';

const Campaign = ({
  index,
  row,
  isChecked,
  onCheckClicked,
  campaignWithOpenDropDown,
  setId,
  totalCampaigns,
  setShowContactsList,
  setSelectedCampaign,
  setIsReadOnlyView,
}) => {
  const dispatch = useDispatch();
  const [openCampaignPreview, setOpenCampaignPreview] = useState(false);
  const [isDuplicating, setIsDuplicating] = useState(false);
  const [isScheduleDetailsModalOpen, setIsScheduleDetailsModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [openPhonePreview, setPhonePreview] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isDuplicateModalOpen, setIsDuplicateModalOpen] = useState(false);

  const clickAwayHandler = () => {
    setId(null);
  };

  const history = useHistory();
  const { domain } = useRouter();
  const isDraftCampaign = row?.status === CampaignStatus.Draft;
  const isScheduledCampaign = row?.status === CampaignStatus.Scheduled;
  const isSentCampaign = row?.status === CampaignStatus.Sent;

  useEffect(() => {
    if (campaignWithOpenDropDown === null) {
      window.removeEventListener('click', clickAwayHandler);
    }
  }, [campaignWithOpenDropDown]);

  const showDeletePopUp = () => {
    setIsDeleteModalOpen(true);
  };

  const showDuplicatePopUp = () => {
    setIsDuplicateModalOpen(true);
  };

  const showScheduleDetails = () => {
    setIsScheduleDetailsModalOpen(true);
  };

  const handleDelete = () => {
    setIsDeleting(true);
    const data = [row?.id];
    CampaignServices.deleteCampaigns(data)
      .then(res => {
        setIsDeleting(false);
        dispatch(fetchAllEmailCampaignsAsync());
      })
      .catch(err => {
        setIsDeleting(false);
      });
  };

  const handleDuplicate = () => {
    setIsDuplicating(true);
    const {
      id,
      emailContent,
      emailSubject,
      fromEmail,
      fromName,
      isGraphicalEmail,
      isSechedule,
      preHeaderText,
      recipients,
      scheduleDateTime,
      scheduleTimeZone,
      title,
      useCustomBrandingColor,
      userId,
      ...rest
    } = row;
    const campaignData = {
      emailContent,
      emailSubject,
      fromEmail,
      fromName,
      isGraphicalEmail,
      isSechedule,
      preHeaderText,
      recipients,
      scheduleDateTime,
      scheduleTimeZone,
      title,
      useCustomBrandingColor,
      userId,
      parentCampaignId: id,
      isDuplicate: true,
    };
    createCampaignServices
      .createDraftCampaign(campaignData)
      .then(res => {
        setIsDuplicating(false);
        dispatch(fetchAllEmailCampaignsAsync());
      })
      .catch(err => {
        setIsDuplicating(false);
      });
  };

  const handleContactsClick = () => {
    setSelectedCampaign(row);
    setIsReadOnlyView(true);
    setShowContactsList(true);
  };

  return (
    <>
      <TableRow className={classes.container}>
        <NarrowTableCell component="th" scope="row">
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <FormControlLabel
              style={{ fontFamily: 'Avenir', marginRight: '5px' }}
              checked={isChecked(row?.id)}
              onChange={() => {
                onCheckClicked(row.id);
              }}
              control={<Checkbox color="primary" />}
              // label={<StyledImage src={DummyImage} />}
              label={<></>}
              name="selected"
              disabled={false}
            />{' '}
            {isDraftCampaign || isScheduledCampaign ? (
              <ContributionTitle
                onClick={() => (window.location.href = addhttp(`${domain}/edit-campaign/${row?.id}/title`))}
              >
                {row?.title}
              </ContributionTitle>
            ) : (
              <ContributionTitle
                onClick={() => {
                  setOpenCampaignPreview(true);
                }}
              >
                {row?.title}
              </ContributionTitle>
            )}
          </div>
        </NarrowTableCell>
        <NarrowTableCell>{row?.fromEmail}</NarrowTableCell>
        <NarrowTableCell align="center">{moment(row?.createTime).format('MMM DD, YYYY')}</NarrowTableCell>
        <NarrowTableCell align="center">
          {isDraftCampaign
            ? '-'
            : isScheduledCampaign
            ? moment(row?.scheduleDateTime).format('MMM DD, YYYY hh:mm A')
            : moment(row?.sentDateTime).format('MMM DD, YYYY hh:mm A')}
        </NarrowTableCell>
        <NarrowTableCell align="center">
          {row?.status === 'Scheduled' ? (
            <HyperLink onClick={showScheduleDetails}>{row?.status}</HyperLink>
          ) : (
            row?.status
          )}
        </NarrowTableCell>
        <NarrowTableCell align="center">
          <StyledContactsCount onClick={handleContactsClick}>{row?.recipients?.length || 0}</StyledContactsCount>
        </NarrowTableCell>
        <NarrowTableCell align="center">
          <StyledDropDownWrapper>
            <MoreHorizIcon
              style={{ cursor: 'pointer' }}
              onClick={e => {
                e.stopPropagation();
                setId(row?.id);
                window.removeEventListener('click', clickAwayHandler);
                window.addEventListener('click', clickAwayHandler);
              }}
            />
            {campaignWithOpenDropDown === row?.id && (
              <StyledDropDown>
                <div>
                  {/* {isDraftCampaign || isScheduledCampaign ? ( */}
                  <StyledDropDownItem
                    isDisabled={row?.emailContent === null || row?.emailContent.length === 0}
                    onClick={() => {
                      if (row?.emailContent != null || row?.emailContent?.length > 0) {
                        setOpenCampaignPreview(true);
                      }
                    }}
                  >
                    Preview
                  </StyledDropDownItem>
                  {/* ) : (
                    <Tooltip title="This email campaign was already sent." arrow>
                      <StyledDropDownItem onClick={() => {}} isDisabled={true}>
                        Preview
                      </StyledDropDownItem>
                    </Tooltip>
                  )} */}
                </div>
                <div>
                  {isDraftCampaign || isScheduledCampaign ? (
                    <StyledDropDownItem
                      onClick={() => {
                        window.location.href = addhttp(`${domain}/edit-campaign/${row?.id}/title`);
                      }}
                    >
                      Edit
                    </StyledDropDownItem>
                  ) : (
                    <Tooltip title="This email campaign was already sent." arrow>
                      <StyledDropDownItem onClick={() => {}} isDisabled={true}>
                        Edit
                      </StyledDropDownItem>
                    </Tooltip>
                  )}
                </div>
                <div>
                  <StyledDropDownItem onClick={showDuplicatePopUp}>Duplicate</StyledDropDownItem>
                </div>
                <div>
                  <StyledDropDownItem onClick={showDeletePopUp}>Delete</StyledDropDownItem>
                </div>
              </StyledDropDown>
            )}
          </StyledDropDownWrapper>
        </NarrowTableCell>
      </TableRow>

      <Modal
        isOpen={isDeleteModalOpen}
        title="Are you sure you want to delete?"
        submitTitle="Delete"
        onSubmit={handleDelete}
        onCancel={() => {
          setIsDeleteModalOpen(false);
        }}
        reduceCancelButton
        disableSubmitClick={isDeleting}
      >
        <div>
          Deleting this email campaign will permanently remove it from your account. This action cannot be undone. Are
          you sure you want to proceed with the deletion?
        </div>
      </Modal>

      <Modal
        isOpen={isDuplicateModalOpen}
        title="Duplicate One-Time Email Campaign"
        submitTitle="Duplicate"
        onSubmit={handleDuplicate}
        onCancel={() => {
          setIsDuplicateModalOpen(false);
        }}
        reduceCancelButton
        widthRequiredIs
        disableSubmitClick={isDuplicating}
      >
        <div>Are you sure you want to duplicate this Email Campaign?</div>
      </Modal>
      <Modal
        isOpen={isScheduleDetailsModalOpen}
        title="Scheduled Date and Time"
        submitTitle="Close"
        onSubmit={() => {
          setIsScheduleDetailsModalOpen(false);
        }}
        onCancel={() => {
          setIsScheduleDetailsModalOpen(false);
        }}
        hiddenCancel
        widthRequiredIs
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', padding: '10px 0px 20px 0px' }}>
          <div>
            {' '}
            <strong>Date:</strong> {moment(row?.scheduleDateTime).format('MMMM DD YYYY')}
          </div>
          <div>
            <strong>Time:</strong> {moment(row?.scheduleDateTime).format('hh:mm A')}
          </div>
          <div>
            <strong>TimeZone:</strong> {row?.scheduleTimeZone}
          </div>
        </div>
      </Modal>
      <Modal
        disableConfirm={true}
        title="Campaign Preview "
        isOpen={openCampaignPreview}
        hiddenCancel
        onCancel={() => {
          setOpenCampaignPreview(false);
          setPhonePreview(false);
        }}
        widthRequired
      >
        <div className={classes.preview_conatiner}>
          <div className={classes.preview_btns}>
            <div className={classes.image} onClick={() => setPhonePreview(true)}>
              <PhonePreviewVector
                fillBackgroundColor={openPhonePreview ? '#F1F8FF' : ''}
                fillColor={openPhonePreview ? '#215C73' : ''}
              />
            </div>
            <div className={classes.image} onClick={() => setPhonePreview(false)}>
              <PhoneDesktop
                fillBackgroundColor={!openPhonePreview ? '#F1F8FF' : ''}
                fillColor={!openPhonePreview ? '#215C73' : ''}
              />
            </div>
          </div>
          <div className={classes.preview_body}>
            <div className={openPhonePreview ? classes.responsive_preview : classes.responsive_desktop_preview}>
              <div dangerouslySetInnerHTML={{ __html: row?.emailContent || Dummy_Template }}></div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

Campaign.propTypes = {};

Campaign.defaultProps = {};

export default Campaign;
